import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getAllRoleScenicAreaId(condition = {}) {
  let response = {}
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/RoleToScenicArea/All`)
  } catch (err) {
    console.error('iisi getAllRoleScenicAreaId: ', err)

  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function putAllRoleScenicAreaId(condition = {}) {
  let response = {}

  if(Utils.isEmptyObject(condition) || Utils.isEmptyObject(condition.roleId) || !Array.isArray(condition.scenicAreaList)) {
    console.error('iisi putAllRoleScenicAreaId: condition error')
  }

  const scenicAreaIdList = condition.scenicAreaList.map(sc => sc.id).sort((a, b) => a - b)

  try {
    response = await axios.put(`${config.eastCoastDataApi()}BaseData/RoleToScenicArea/Role/${condition.roleId}`, scenicAreaIdList)
  } catch (err) {
    console.error('iisi putAllRoleScenicAreaId: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response
}